<template>
	<div class="orders">
		<pageCart title="Ordrehistorik">
			<div class="items" v-if="items">
				<item v-for="item in items" :key="item.id" v-bind="item"/>
			</div>

			<div class="empty" v-if="items && !items.length">Ingen ordrer fundet</div>
		</pageCart>
	</div>
</template>

<script>
import pageCart from "@/components/layouts/page/cart.vue";
import item from "./item.vue";

export default {
	components: {pageCart, item},
	data() {
		return {
			items: null
		}
	},
	methods: {
		async getData() {
			const {data: {data}} = await this.$axios.get("client/orders", {params: {count: 1000, sort: "-confirmed_at"}});
			this.items = data;
		}
	},
	created() {
		this.getData();
	}
};
</script>

<style lang="scss" scoped>
.orders {

}
</style>
